/* ============================================================================
   sf-size-engine.js — STARKBOOTS Groessen-Logik (einzige Quelle), 24.09.2026

   Jede Groessenempfehlung der Seite kommt hier heraus: Popup "Welche Größe
   passt dir?" (Tipp in den Set-Karten), Reiter "Groesse & Passform"
   (snippets/sf-size-helper.liquid), alter Inline-Rechner <sf-size-helper>
   (assets/sf-buybox.js) und der grosse Groessenfinder
   (sections/starkboots-sizefinder.liquid). Keine zweite Kopie der Regeln.

   ALLE Stellschrauben stehen NUR im Block SETTINGS unten: Tabelle (TABLE,
   mit Anzeige-Texten "show"), Grenzregel (BOUNDARY), Tie-Break (TIEBREAK),
   Plausibilitaet (PLAUSIBILITY), Messanleitung (MEASURE), Eingabebereiche
   (LIMITS). Ein Tabellenwechsel ist ein Tausch dieses Blocks; danach
   Testmatrix, Raster-Test und Tabellen-Check laufen lassen. Der Reiter
   "Groesse & Passform" und der grosse Finder zeigen die Tabelle aus
   describe(), nicht mehr aus der Shopify-Seite "starkboots-groessentabelle".

   Tabelle seit 24.09.2026 (Nayls Go ~16:40; Recherche: Mails 2024-2026,
   1.710 Bestellungen, Schrittlaenge = Schritt bis Boden, barfuss):
     Oberschenkel   S < 70 | M 70 bis < 74 | L 74 bis 83,0 | > 83 zu eng
     Schrittlaenge  S < 76 | M 76 bis < 86 | L >= 86
     nur Koerper    S < 168,5 | M 168,5 bis < 188,5 | L >= 188,5
                    (ganze cm: S bis 168, M 169-188, L ab 189; nur fuer
                    Aufrufer ohne Schrittlaenge)
   Ein Grenzwert gehoert zur naechsten Groesse (BOUNDARY 'next'), die
   Obergrenze von L (83 / 91 / 198) ist inklusiv.

   Regeln (Eingaben auf 0,1 cm gerundet):
   1. Einziger Zustand ohne Empfehlung: Oberschenkel ueber 83,0 cm -> "zu
      eng", confidence "none", Kontakt. Sonst IMMER genau eine Groesse.
   2. Groesse = die groessere aus Weite (Oberschenkel) und Laenge
      (Schrittlaenge; fehlt sie, die Koerpergroesse). Zeigt die Laenge
      kleiner als die Weite (auch zwei Groessen), gewinnt die Weite.
   3. Ausserhalb der Tabelle (Schrittlaenge < 66 / > 91, Koerpergroesse
      < 155 / > 198): S bzw. L mit kurzem Hinweis.
   4. Plausibilitaet: Schrittlaenge / Koerpergroesse ausserhalb 0,40-0,52
      -> Hinweis "nachmessen" (unter "Warum?"), Groesse bleibt, hoechstens
      "Grenzfall".
   5. Ohne Oberschenkel: Satz nur mit der Groesse (Popup fragt seit
      25.09.2026 keinen Oberschenkel mehr ab, Nayl).
   6. Sicherheit: "high" = Weite und Laenge zeigen dieselbe Groesse, in der
      Tabelle, plausibel; "medium" = Weite schlaegt Laenge, Rand oder
      unplausibel; "low" = ohne Oberschenkel; "none" = nur zu eng.
   7. Koerperbau (Quiz) aendert nie die Groesse, ohne Oberschenkelmass nur
      ein Mess-Hinweis. Geschlecht und Gewicht werden nicht verwendet.
   8. TIEBREAK greift nur, wenn sich Spalten ueberlappen oder Luecken
      haben (bei der Tabelle seit 24.09.2026 nie).

   API (Browser: window.SFSizeEngine, Node: module.exports)
     recommend({ thigh, inseam, height, build? }) -> {
       ok, size ('S'|'M'|'L'|null nur bei zu eng), label, confidence
       ('high'|'medium'|'low'|'none'), level, title, summary (ein Satz fuer
       die Oberflaeche), reason (Details fuer "Warum?"), warnings: [{ code,
       level, text }], alternative, nearest, contact, basis, inputs, errors }
     describe('M') -> { size, label, height, thigh, inseam (mit ' cm'),
       bare: { height, thigh, inseam } (ohne Einheit, fuer Tabellen) }
     parse('72,5') -> 72.5   format(72.5) -> '72,5'
     TABLE, BOUNDARY, TIEBREAK, PLAUSIBILITY, MEASURE, LIMITS, SETTINGS
     create({ TABLE: [...], BOUNDARY: 'next', ... }) -> eigene Engine mit
       geaenderten Einstellungen (nur fuer Tests/Vorschau; die Seite nutzt
       immer SETTINGS)
   Wer vor dem Laden rechnen will: (window.__sfSizeEngineQueue ||= []).push(fn)
   ============================================================================ */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module && module.exports) module.exports = api;
  if (root && !root.SFSizeEngine) {
    root.SFSizeEngine = api;
    var queued = root.__sfSizeEngineQueue;
    root.__sfSizeEngineQueue = { push: function (fn) { try { fn(api); } catch (e) { /* caller's problem */ } } };
    if (queued && queued.length) {
      for (var q = 0; q < queued.length; q++) {
        try { queued[q](api); } catch (e) { /* caller's problem */ }
      }
    }
    try {
      if (root.document && typeof root.CustomEvent === 'function') {
        root.document.dispatchEvent(new root.CustomEvent('sf:size-engine-ready'));
      }
    } catch (e) { /* old browser */ }
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  /* ============================================================= SETTINGS */
  var SETTINGS = {
    version: '2026-09-24.5',
    /* Groessentabelle; Grenzen in cm. height/inseam = [von, bis],
       thighMax = obere Oberschenkel-Grenze; show = Anzeige (Reiter-Tabelle,
       grosser Finder, "Warum?"), ohne Einheit. */
    TABLE: [
      { size: 'S', label: 'Small', height: [155, 168.5], thighMax: 70, inseam: [66, 76],
        show: { height: 'bis 168', thigh: 'unter 70', inseam: 'unter 76' } },
      { size: 'M', label: 'Medium', height: [168.5, 188.5], thighMax: 74, inseam: [76, 86],
        show: { height: '169–188', thigh: '70 bis unter 74', inseam: '76 bis unter 86' } },
      { size: 'L', label: 'Large', height: [188.5, 198], thighMax: 83, inseam: [86, 91],
        show: { height: 'ab 189', thigh: '74–83', inseam: 'ab 86' } }
    ],
    /* Wem gehoert ein Wert genau auf einer oberen Grenze?
       'inclusive' = der Groesse selbst (70,0 cm -> S, "bis 70 cm");
       'next'      = der naechsten Groesse (70,0 cm -> M, "unter 70 cm");
       die obere Grenze der groessten Groesse ist immer inklusiv. */
    BOUNDARY: 'next',
    TIEBREAK: {
      /* Schrittlaenge in einer Ueberlappung ohne Koerpergroesse */
      overlapWithoutHeight: 'smaller',
      /* Koerpergroesse genau in der Mitte einer Luecke */
      gapMiddle: 'larger'
    },
    /* null = aus. Sonst { inseamToHeight: [min, max], text }: liegt
       Schrittlaenge / Koerpergroesse ausserhalb, kommt text als Hinweis. */
    PLAUSIBILITY: {
      inseamToHeight: [0.40, 0.52],
      text: 'Schrittlänge und Körpergröße passen nicht recht zusammen – miss die Schrittlänge bitte noch einmal nach (innen am Bein, vom Schritt bis zum Boden, barfuß).'
    },
    /* Messanleitung Schrittlaenge; derselbe Wortlaut steht im Popup, im
       Reiter, im alten Rechner und im grossen Finder (Standardwert). */
    MEASURE: {
      inseam: 'Innen am Bein, vom Schritt bis zum Boden, barfuß.'
    },
    LIMITS: {
      thigh: { min: 45, max: 100, name: 'Oberschenkelumfang' },
      inseam: { min: 55, max: 100, name: 'Schrittlänge' },
      height: { min: 140, max: 220, name: 'Körpergröße' }
    }
  };
  /* ====================================================================== */

  var TITLES = { high: 'Deine Größe: ', medium: 'Wir empfehlen ', low: 'Vorläufig: ' };
  var LEVELS = { high: 'Passt laut Größentabelle', medium: 'Grenzfall', low: 'Orientierung', none: 'Zu eng' };
  var CONTACT = 'Melde dich gern kurz bei unserem Kundenservice – wir finden eine Lösung.';

  /* "72,5", "72.5 cm", 72.5 -> 72.5; leer -> null; Unsinn -> NaN */
  function parse(v) {
    if (v === null || v === undefined) return null;
    if (typeof v === 'number') return isFinite(v) ? Math.round(v * 10) / 10 : NaN;
    var s = String(v).trim().toLowerCase().replace(/\s*cm$/, '').replace(/\s+/g, '').replace(',', '.');
    if (!s) return null;
    if (!/^\d+(\.\d+)?$/.test(s)) return NaN;
    return Math.round(parseFloat(s) * 10) / 10;
  }

  function format(n) {
    if (n === null || n === undefined || isNaN(n)) return '';
    return (Math.round(n * 10) / 10).toString().replace('.', ',');
  }

  /* geschuetzte Leerzeichen: "cm" und Bereiche brechen nie auseinander */
  function cm(v) { return format(v) + ' cm'; }

  function build(cfg) {
    var VERSION = cfg.version;
    var TABLE = cfg.TABLE;
    var TIEBREAK = cfg.TIEBREAK;
    var LIMITS = cfg.LIMITS;
    var NEXT = cfg.BOUNDARY === 'next';
    var ORDER = TABLE.map(function (r) { return r.size; });
    var LAST = TABLE.length - 1;

    /* Liegt v in Zeile k der Spalte col? Untere Grenze inklusiv, obere je
       nach BOUNDARY (die der letzten Zeile immer inklusiv). */
    function within(v, k, col) {
      var r = TABLE[k][col];
      return v >= r[0] && (NEXT && k < LAST ? v < r[1] : v <= r[1]);
    }
    function underThighMax(t, k) {
      return NEXT && k < LAST ? t < TABLE[k].thighMax : t <= TABLE[k].thighMax;
    }
    /* Anzeige: "bis 70 cm" / "unter 70 cm", "66–79 cm" / "66 bis unter 76 cm" */
    function upTo(k) {
      return (NEXT && k < LAST ? 'unter ' : 'bis ') + format(TABLE[k].thighMax) + ' cm';
    }
    function range(k, col) {
      var r = TABLE[k][col];
      if (TABLE[k].show && TABLE[k].show[col]) return TABLE[k].show[col] + '\u00a0cm';
      return NEXT && k < LAST
        ? format(r[0]) + ' bis unter ' + format(r[1]) + ' cm'
        : format(r[0]) + '⁠–⁠' + format(r[1]) + ' cm';
    }

    /* Weite: kleinste Groesse, deren Grenze der Oberschenkel nicht ueberschreitet */
    function widthFloor(t) {
      for (var k = 0; k < TABLE.length; k++) if (underThighMax(t, k)) return k;
      return -1;
    }

    /* Koerpergroesse -> Spalten-Kandidaten (in / Luecke / Rand) */
    function heightCands(h) {
      for (var k = 0; k < TABLE.length; k++) if (within(h, k, 'height')) return { c: [k], how: 'in' };
      if (h < TABLE[0].height[0]) return { c: [0], how: 'below' };
      if (h > TABLE[LAST].height[1]) return { c: [LAST], how: 'above' };
      for (var g = 0; g < LAST; g++) {
        if (h > TABLE[g].height[1] && h < TABLE[g + 1].height[0]) return { c: [g, g + 1], how: 'gap' };
      }
      return { c: [0], how: 'below' };
    }

    /* Schrittlaenge -> Spalten-Kandidaten (in / Ueberlappung / Rand) */
    function inseamCands(i) {
      if (i < TABLE[0].inseam[0]) return { c: [0], how: 'below' };
      if (i > TABLE[LAST].inseam[1]) return { c: [LAST], how: 'above' };
      var c = [];
      for (var k = 0; k < TABLE.length; k++) if (within(i, k, 'inseam')) c.push(k);
      return { c: c, how: c.length > 1 ? 'overlap' : 'in' };
    }

    /* Luecke: die naehere Groesse, genau in der Mitte nach TIEBREAK.gapMiddle */
    function nearestInGap(h, lo, hi) {
      var dLo = h - TABLE[lo].height[1];
      var dHi = TABLE[hi].height[0] - h;
      if (dLo < dHi) return lo;
      if (dHi < dLo) return hi;
      return TIEBREAK.gapMiddle === 'larger' ? hi : lo;
    }

    /* Koerpergroesse als eine Groesse (fuer Tie-Break und Plausibilitaet) */
    function heightIdx(h) {
      var hc = heightCands(h);
      return hc.how === 'gap' ? nearestInGap(h, hc.c[0], hc.c[1]) : hc.c[0];
    }

    function result(o) {
      var size = o.size === null || o.size === undefined ? null : ORDER[o.size];
      var title = o.title || (size && TITLES[o.confidence] ? TITLES[o.confidence] + size : 'Leider zu eng');
      return {
        ok: o.ok !== false,
        size: size,
        label: size ? TABLE[o.size].label : null,
        confidence: o.confidence,
        level: LEVELS[o.confidence] || '',
        title: title,
        summary: o.summary || '',
        reason: o.reason || '',
        warnings: o.warnings || [],
        alternative: o.alternative === undefined || o.alternative === null ? null : ORDER[o.alternative],
        nearest: o.nearest === undefined || o.nearest === null ? size : ORDER[o.nearest],
        contact: !!o.contact,
        basis: o.basis || 'measures',
        inputs: o.inputs,
        errors: o.errors || [],
        version: VERSION
      };
    }

    function recommend(input) {
      input = input || {};
      var t = parse(input.thigh);
      var i = parse(input.inseam);
      var h = parse(input.height);
      var inputs = { thigh: t, inseam: i, height: h };
      var errors = [];
      [['thigh', t], ['inseam', i], ['height', h]].forEach(function (p) {
        var lim = LIMITS[p[0]];
        if (p[1] === null) return;
        if (isNaN(p[1]) || p[1] < lim.min || p[1] > lim.max) {
          errors.push({ field: p[0], text: 'Bitte gib für ' + lim.name + ' einen Wert zwischen ' + lim.min + ' und ' + lim.max + ' cm ein.' });
        }
      });
      if (errors.length) {
        return result({ ok: false, confidence: 'none', size: null, title: 'Bitte Eingaben prüfen', summary: errors[0].text, reason: errors[0].text, errors: errors, inputs: inputs, basis: 'none' });
      }
      if (t === null && i === null && h === null) {
        return result({ ok: false, confidence: 'none', size: null, title: 'Maße eingeben', summary: 'Gib deine Körpergröße oder deine Maße ein.', inputs: inputs, basis: 'none' });
      }

      var W = [];
      var L = TABLE[LAST];

      /* 1. Einziger Zustand ohne Empfehlung */
      if (t !== null && t > L.thighMax) {
        return result({
          size: null, confidence: 'none', contact: true, nearest: LAST, inputs: inputs, warnings: W,
          basis: i !== null ? 'measures' : 'partial',
          summary: 'Für deinen Oberschenkel sind die STARKBOOTS leider zu eng.',
          reason: 'Dein Oberschenkelumfang (' + cm(t) + ') liegt über der größten Weite: ' + L.label + ' reicht bis ' + format(L.thighMax) + ' cm. ' + CONTACT
        });
      }

      var floor = t !== null ? widthFloor(t) : 0;
      var lenBy = i !== null ? 'inseam' : h !== null ? 'height' : null;

      /* nur Oberschenkel */
      if (!lenBy) {
        var F0 = TABLE[floor];
        W.push({ code: 'length-missing', level: 'info', text: 'Mit Körpergröße oder Schrittlänge wird die Empfehlung genauer.' });
        return result({
          size: floor, confidence: 'low', basis: 'partial', inputs: inputs, warnings: W,
          summary: 'Nach deinem Oberschenkel passt ' + F0.size + ' – mit Körpergröße wird es genauer.',
          reason: 'Oberschenkel ' + cm(t) + ': ab ' + F0.size + ' (' + upTo(floor) + ').'
        });
      }

      /* Laenge -> Kandidaten, Weite als Untergrenze, dann Tie-Break */
      var lc = lenBy === 'inseam' ? inseamCands(i) : heightCands(h);
      var cands = lc.c;
      var cf = cands.filter(function (k) { return k >= floor; });
      var size;
      var mode;           /* same | conflict | width | tie-height | tie-smaller | gap-nearest | gap-width */
      var alternative = null;
      if (!cf.length) {
        size = floor;
        mode = 'conflict';
        alternative = cands[cands.length - 1];
      } else if (cf.length === 1) {
        size = cf[0];
        mode = cands.length > 1 ? (lc.how === 'gap' ? 'gap-width' : 'width') : 'same';
      } else if (lc.how === 'gap') {
        size = nearestInGap(h, cf[0], cf[1]);
        mode = 'gap-nearest';
        alternative = size === cf[0] ? cf[1] : cf[0];
      } else if (h !== null) {
        var hi = heightIdx(h);
        size = cf.indexOf(hi) !== -1 ? hi : (hi < cf[0] ? cf[0] : cf[1]);
        mode = 'tie-height';
        alternative = size === cf[0] ? cf[1] : cf[0];
      } else {
        size = TIEBREAK.overlapWithoutHeight === 'larger' ? cf[1] : cf[0];
        mode = 'tie-smaller';
        alternative = size === cf[0] ? cf[1] : cf[0];
      }
      var S = TABLE[size];
      var edge = lc.how === 'below' || lc.how === 'above';
      var lenWord = lenBy === 'inseam' ? 'Beinlänge' : 'Körpergröße';

      /* Details fuer "Warum?" */
      var parts = [];
      if (t !== null) {
        parts.push('Oberschenkel ' + cm(t) + ': ab ' + TABLE[floor].size + (floor > 0 ? ' (' + TABLE[floor - 1].size + ' ' + upTo(floor - 1) + ')' : ' (' + upTo(0) + ')') + '.');
      }
      var col = lenBy === 'inseam' ? 'inseam' : 'height';
      var val = lenBy === 'inseam' ? i : h;
      var name = lenBy === 'inseam' ? 'Schrittlänge' : 'Körpergröße';
      if (lc.how === 'below') parts.push(name + ' ' + cm(val) + ': unter der Tabelle (' + TABLE[0].size + ' ab ' + format(TABLE[0][col][0]) + ' cm).');
      else if (lc.how === 'above') parts.push(name + ' ' + cm(val) + ': über der Tabelle (' + L.size + ' bis ' + format(L[col][1]) + ' cm).');
      else if (cands.length === 1) parts.push(name + ' ' + cm(val) + ': ' + TABLE[cands[0]].size + ' (' + range(cands[0], col) + ').');
      else if (lc.how === 'gap') parts.push(name + ' ' + cm(val) + ': zwischen ' + ORDER[cands[0]] + ' (bis ' + format(TABLE[cands[0]].height[1]) + ' cm) und ' + ORDER[cands[1]] + ' (ab ' + format(TABLE[cands[1]].height[0]) + ' cm).');
      else parts.push(name + ' ' + cm(val) + ': ' + ORDER[cands[0]] + ' und ' + ORDER[cands[1]] + ' möglich.');
      if (mode === 'conflict') parts.push('Die Weite hat Vorrang, deshalb ' + S.size + '.');
      else if (mode === 'width' || mode === 'gap-width') parts.push('Die Weite schließt ' + ORDER[cands[0]] + ' aus, deshalb ' + S.size + '.');
      else if (mode === 'tie-height') parts.push('Bei deiner Körpergröße (' + cm(h) + ') passt ' + S.size + '.');
      else if (mode === 'tie-smaller') parts.push('Ohne Körpergröße nehmen wir die kleinere, ' + S.size + '.');
      else if (mode === 'gap-nearest') parts.push(S.size + ' liegt näher.');

      /* ein Satz fuer die Oberflaeche */
      var summary;
      if (t === null) {
        summary = 'Nach deiner ' + (lenBy === 'inseam' ? 'Schrittlänge' : 'Körpergröße') + ' passt ' + S.size + '.';
      } else if (mode === 'conflict') {
        summary = 'Dein Oberschenkel braucht ' + S.size + ', auch wenn deine ' + lenWord + ' eher zu ' + ORDER[alternative] + ' passt.';
      } else if (edge) {
        summary = lc.how === 'below'
          ? 'Du liegst unter der Größentabelle – ' + S.size + ' ist die kleinste Größe.'
          : 'Du liegst über der Größentabelle – ' + S.size + ' ist die größte Größe.';
      } else if (mode === 'gap-nearest') {
        summary = 'Mit ' + cm(h) + ' liegst du zwischen ' + ORDER[cf[0]] + ' und ' + ORDER[cf[1]] + ' – näher an ' + S.size + '.';
      } else if (mode === 'gap-width') {
        summary = 'Mit ' + cm(h) + ' liegst du zwischen ' + ORDER[cands[0]] + ' und ' + ORDER[cands[1]] + ' – dein Oberschenkel entscheidet: ' + S.size + '.';
      } else if (mode === 'tie-height') {
        summary = 'Deine Schrittlänge passt zu ' + ORDER[cf[0]] + ' und ' + ORDER[cf[1]] + ' – mit ' + cm(h) + ' wird es ' + S.size + '.';
      } else if (mode === 'tie-smaller') {
        summary = 'Deine Schrittlänge passt zu ' + ORDER[cf[0]] + ' und ' + ORDER[cf[1]] + ' – wir nehmen die kleinere, ' + S.size + '.';
      } else {
        summary = 'Laut Größentabelle ist ' + S.size + ' deine Größe.';
      }

      /* kurze Infos: Rand, Plausibilitaet, fehlende Weite */
      if (edge && (mode === 'conflict' || t === null)) {
        W.push({ code: lc.how === 'below' ? 'edge-below' : 'edge-above', level: 'info', text: 'Deine ' + name + ' liegt ' + (lc.how === 'below' ? 'unter' : 'über') + ' der Tabelle.' });
      }
      if (lenBy === 'inseam' && h !== null) {
        var hc = heightCands(h);
        if (hc.how === 'below' || hc.how === 'above') {
          W.push({ code: 'height-outside', level: 'info', text: 'Deine Körpergröße (' + cm(h) + ') liegt außerhalb der Tabelle – maßgeblich sind deine Beinmaße.' });
        } else if (Math.abs(heightIdx(h) - size) >= 2) {
          W.push({ code: 'height-far', level: 'info', text: 'Deine Körpergröße (' + cm(h) + ') passt laut Tabelle zu ' + ORDER[heightIdx(h)] + ' – maßgeblich sind deine Beinmaße.' });
        }
      }
      var doubtful = false;
      var P = cfg.PLAUSIBILITY;
      if (P && P.inseamToHeight && i !== null && h !== null) {
        var q = i / h;
        if (q < P.inseamToHeight[0] || q > P.inseamToHeight[1]) {
          doubtful = true;
          W.push({ code: 'measure-check', level: 'warn', text: P.text || 'Schrittlänge und Körpergröße passen nicht recht zusammen – miss die Schrittlänge bitte noch einmal nach.' });
        }
      }
      if (t === null) {
        var over = NEXT && size < LAST ? format(S.thighMax) + ' cm oder mehr' : 'mehr als ' + format(S.thighMax) + ' cm';
        W.push({ code: 'thigh-missing', level: 'info', text: size < LAST
          ? 'Misst dein Oberschenkel an der kräftigsten Stelle ' + over + ', brauchst du mindestens ' + ORDER[size + 1] + '.'
          : 'Misst dein Oberschenkel an der kräftigsten Stelle ' + over + ', sind die STARKBOOTS zu eng.' });
        if (input.build === 'athletic' || input.build === 'broad') {
          W.push({ code: 'build-strong', level: 'warn', text: 'Du hast kräftige Beine angegeben – miss deshalb bitte kurz deinen Oberschenkel.' });
        }
      }

      var confidence = t === null ? 'low'
        : (mode === 'conflict' || edge || mode === 'tie-height' || mode === 'tie-smaller' || mode === 'gap-nearest' || mode === 'gap-width' || doubtful) ? 'medium'
        : 'high';
      return result({
        size: size, confidence: confidence, alternative: alternative, inputs: inputs, warnings: W,
        basis: t === null ? (lenBy === 'height' ? 'height' : 'partial') : (lenBy === 'inseam' ? 'measures' : 'partial'),
        summary: summary, reason: parts.join(' ')
      });
    }

    function sizeInfo(size) {
      var k = ORDER.indexOf(String(size || '').charAt(0).toUpperCase());
      return k === -1 ? null : TABLE[k];
    }

    /* Anzeige-Texte einer Tabellenzeile (Reiter-Tabelle, grosser Finder) */
    function describe(size) {
      var k = ORDER.indexOf(String(size || '').charAt(0).toUpperCase());
      if (k === -1) return null;
      var r = TABLE[k];
      var bare = function (col) {
        if (r.show && r.show[col]) return r.show[col];
        if (col === 'thigh') return upTo(k).replace(/\u00a0cm$/, '');
        return NEXT && k < LAST ? format(r[col][0]) + ' bis unter ' + format(r[col][1]) : format(r[col][0]) + '–' + format(r[col][1]);
      };
      var b = { height: bare('height'), thigh: bare('thigh'), inseam: bare('inseam') };
      return { size: r.size, label: r.label, height: b.height + ' cm', thigh: b.thigh + ' cm', inseam: b.inseam + ' cm', bare: b };
    }

    return {
      version: VERSION,
      ORDER: ORDER.slice(),
      TABLE: TABLE,
      BOUNDARY: NEXT ? 'next' : 'inclusive',
      TIEBREAK: TIEBREAK,
      PLAUSIBILITY: cfg.PLAUSIBILITY,
      MEASURE: cfg.MEASURE,
      LIMITS: LIMITS,
      LEVELS: LEVELS,
      CONTACT: CONTACT,
      SETTINGS: cfg,
      parse: parse,
      format: format,
      sizeInfo: sizeInfo,
      describe: describe,
      recommend: recommend
    };
  }

  var api = build(SETTINGS);
  /* Eigene Engine mit geaenderten Einstellungen (Tests, Vorschau einer neuen
     Tabelle). Nicht genannte Einstellungen kommen aus SETTINGS. */
  api.create = function (over) {
    var cfg = {};
    Object.keys(SETTINGS).forEach(function (k) { cfg[k] = SETTINGS[k]; });
    Object.keys(over || {}).forEach(function (k) { cfg[k] = over[k]; });
    return build(cfg);
  };
  return api;
});
